import * as React from "react";
import Modal from "@material-ui/core/Modal";
import isEmail from "validator/lib/isEmail";

const FIELDS = [
    { name: "username", label: "Username", type: "text", autoComplete: "off" },
    { name: "firstname", label: "First name", type: "text", autoComplete: "off" },
    { name: "lastname", label: "Last name", type: "text", autoComplete: "off" },
    { name: "emailid", label: "Email", type: "email", autoComplete: "off" },
    { name: "password", label: "Password", type: "password", autoComplete: "new-password" },
];

const EMPTY_VALUES = { username: "", firstname: "", lastname: "", emailid: "", password: "" };

const TeacherPortalAddStudentModal = ({ onClose, onSubmit }) => {
    const [values, setValues] = React.useState(EMPTY_VALUES);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [submitting, setSubmitting] = React.useState(false);

    const handleChange = (e) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const validate = () => {
        const missing = FIELDS.find((field) => values[field.name].trim().length === 0);
        if (missing) {
            return `Please fill in the ${missing.label.toLowerCase()}.`;
        }
        if (!isEmail(values.emailid.trim())) {
            return "Please fill in a valid email address.";
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationError = validate();
        setErrorMessage(validationError);
        if (validationError) {
            return;
        }

        setSubmitting(true);
        try {
            if (onSubmit) {
                await onSubmit({
                    username: values.username.trim(),
                    firstname: values.firstname.trim(),
                    lastname: values.lastname.trim(),
                    emailid: values.emailid.trim(),
                    password: values.password,
                });
            }
            onClose();
        } catch (err) {
            setErrorMessage("Something went wrong while adding the student. Please try again.");
            setSubmitting(false);
        }
    };

    return <Modal open onClose={() => { onClose() }}>
        <form
            noValidate
            onSubmit={handleSubmit}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2/5 min-w-[320px] max-h-[90vh] overflow-auto bg-white rounded shadow outline-none text-left"
        >
            <h2 className="p-4 text-2xl">Add student</h2>
            <div className="p-4">
                <p className="text-slate-500">Not implemented yet.</p>
            </div>
            <hr className="border-black/10" />
            <div className="p-4 flex flex-col gap-3">
                {FIELDS.map((field) => (
                    <label key={field.name} className="flex flex-col gap-1 text-sm">
                        {field.label}
                        <input
                            className="shadow-default rounded p-2 text-base"
                            name={field.name}
                            type={field.type}
                            autoComplete={field.autoComplete}
                            value={values[field.name]}
                            onChange={handleChange}
                        />
                    </label>
                ))}
                {errorMessage && <div className="text-base text-error">{errorMessage}</div>}
            </div>
            <hr className="border-black/10" />
            <div className="p-4 flex justify-end gap-2">
                <button
                    type="button"
                    className="bg-card_dark px-4 py-2 rounded hover:opacity-90"
                    onClick={() => onClose()}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={submitting}
                    className="bg-link text-txt_secondary px-8 py-2 rounded shadow-default hover:opacity-90 disabled:opacity-50"
                >
                    Add student
                </button>
            </div>
        </form>
    </Modal>
}

export default TeacherPortalAddStudentModal;
